<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Dashboard</h1>

    <div class="flex flex-wrap">
      <div class="w-full lg:w-1/3 px-2">
        <div class="bg-white rounded-md shadow overflow-hidden mb-8">
          <div class="px-6 py-4 bg-gray-50 border-t border-gray-100 font-semibold">
            Upcoming Events
          </div>
          <div v-for="event in events" :key="event.id" class="border-t border-gray-100 hover:bg-gray-100 focus-within:bg-gray-100">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('events.show', event.id)">
              {{ event.name }}
            </inertia-link>
          </div>
          <div v-if="events.length === 0" class="border-t border-gray-100 px-6 py-4">
            No events found.
          </div>
          <div class="px-6 py-4 bg-gray-50 border-t border-gray-100">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">
              All Events
            </inertia-link>
          </div>
        </div>
      </div>

      <div class="w-full lg:w-1/3 px-2">
        <div class="bg-white rounded-md shadow overflow-hidden mb-8">
          <div class="px-6 py-4 bg-gray-50 border-t border-gray-100 font-semibold">
            Activity Log
          </div>
          <div v-for="activity in activities" :key="activity.id" class="border-t border-gray-100 hover:bg-gray-100 focus-within:bg-gray-100">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('activity.show', activity.id)">
              <div class="flex flex-col">
                <div class="pb-1">{{ activity.causer }} {{ activity.description }} {{ activity.subject }}</div>
                <div class="italic">{{ dateFormat(activity.timestamp) }}</div>
              </div>
            </inertia-link>
          </div>
          <div v-if="activities.length === 0" class="border-t border-gray-100 px-6 py-4">
            No changes found.
          </div>
          <div class="px-6 py-4 bg-gray-50 border-t border-gray-100">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('activity.index')">
              All Activity
            </inertia-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { DateTime } from "luxon";

export default {
  metaInfo: { title: 'Dashboard' },
  props: {
    events: Array,
    activities: Array,
  },
  layout: Layout,
  methods: {
    dateFormat(iso) {
      return DateTime.fromISO(iso).toLocaleString(DateTime.DATETIME_FULL)
    },
  }
}
</script>